export default {
  "btn.ok" : "OK",
  "btn.cancel": "CANCEL",
  "btn.close": "CLOSE",
  "btn.login": "LOGIN",
  "btn.search": "SEARCH",

  "validation.required": "Required",

  "msg.err.timecheck": "Session Timeout { value }",

  "system.menu.logout": "Logout",
  
  "login.title": "Login",
  "account.title": "User Management",
  "list.title": "List View",

  "login.label.loginid": "Login ID",
  "login.label.password": "Password",

  "account.label.lastname": "lastname",
  "account.label.firstname": "firstname",
  "account.label.address": "address",
  "account.label.age": "age",
  "account.label.email": "mailaddress",
  "account.label.count": "count",
  "account.label.sex": "sex",
  "account.label.hobby": "hobby",

  "account.item.sex.male": "male",
  "account.item.sex.female": "female",
  "account.item.hobby.movie": "movie",
  "account.item.hobby.drive": "drive",

  "list.columns.download": "DL",
  "list.columns.name": "User Name",
  "list.columns.count": "Data Count",

};